import {useRef} from 'react';
import isEqual from 'react-fast-compare';

/**
 * This hook takes a value and will only return a new value if the value is *actually* different from the
 * previous value.
 *
 * It is useful for creating stable references for values that are considered the same by either deep
 * equality or some other custom equality function.
 *
 * See also memoizeLastCall for a similar non-React hook that can be used for similar behavior in more pure JS
 * contexts.
 */
export default function useStableValue<T>(value: T, equalityFn: (a: T, b: T) => boolean = isEqual): T {
  const ref = useRef<T>(value);
  if (!equalityFn(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
}
